import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import StatsSection from './StatsSection';
import Testimonials from './Testimonials';
import HeroTripCards from './HeroTripCards';
import { db } from '../../firebase';
import { doc, getDoc } from 'firebase/firestore';

function HeroSection() {
  const [searchQuery, setSearchQuery] = useState('');
  const [placeholder, setPlaceholder] = useState('');
  const [heroImageUrl, setHeroImageUrl] = useState('');
  const navigate = useNavigate();

  // Typing animation for placeholder
  useEffect(() => {
    const destinations = [
      'Ladakh',
      'Manali',
      'Spiti',
      'Romantic Getaways',
      'Kashmir',
      'Meghalaya',
      'Bali',
      'Dubai'
    ];
    let destIdx = 0;
    let charIdx = 0;
    let typing = true;
    let timeoutId;

    function type() {
      if (typing) {
        if (charIdx <= destinations[destIdx].length) {
          setPlaceholder(`Type for ${destinations[destIdx].slice(0, charIdx)}`);
          charIdx++;
          timeoutId = setTimeout(type, 90);
        } else {
          typing = false;
          timeoutId = setTimeout(type, 1200);
        }
      } else {
        if (charIdx > 0) {
          setPlaceholder(`Type for ${destinations[destIdx].slice(0, charIdx)}`);
          charIdx--;
          timeoutId = setTimeout(type, 40);
        } else {
          typing = true;
          destIdx = (destIdx + 1) % destinations.length;
          timeoutId = setTimeout(type, 500);
        }
      }
    }
    type();
    return () => clearTimeout(timeoutId);
  }, []);

  // Fetch hero image from Firestore
  useEffect(() => {
    async function fetchHeroImage() {
      try {
        const docRef = doc(db, "Images", "AllImages");
        const docSnap = await getDoc(docRef);
        if (docSnap.exists() && docSnap.data().Hero && docSnap.data().Hero.url) {
          setHeroImageUrl(docSnap.data().Hero.url);
        }
      } catch (error) {
        // fallback: do nothing, keep default
      }
    }
    fetchHeroImage();
  }, []);

  const handleSearch = () => {
    navigate(`/search?q=${encodeURIComponent(searchQuery.trim())}`);
  };

  return (
    <section
      className="hero-section d-none d-lg-block"
      style={heroImageUrl
        ? {
            background: `linear-gradient(rgba(0, 0, 0, 0.9), rgba(0, 0, 0, 0.6)), url('${heroImageUrl}') no-repeat center center`,
            backgroundSize: 'cover'
          }
        : undefined
      }
    >
      <div className="container">
        <div className="row align-items-start">
          {/* Left Column: Content */}
          <div className="col-lg-6 hero-content">
            <h1 className="display-3 fw-bold text-white">
              Book Your <br />Trip to <span className="destination-text">Spiti</span>
            </h1>
            <div className="tagline mt-4 mb-3">
              <span className="text-lime">Explore</span> | 
              <span className="text-white"> Dream</span> | 
              <span className="text-lime"> Discover</span> | 
              <span className="text-white"> Share</span>
              <div className="mt-2 text-white">
                Creating Memories, One Journey at a Time<br />
                <span className="hashtag">#adventureAwaits</span>
              </div>
            </div>
            {/* Search bar */}
            <div className="search-container mb-4">
              <div className="input-group">
                <input
                  type="text"
                  className="form-control rounded-pill rounded-end"
                  placeholder={placeholder || "Search your destination..."}
                  value={searchQuery}
                  onChange={e => setSearchQuery(e.target.value)}
                  onKeyDown={e => { if (e.key === 'Enter') handleSearch(); }}
                />
                <button
                  className="btn btn-primary rounded-pill rounded-start"
                  type="button"
                  onClick={handleSearch}
                  style={{ backgroundColor: '#FFA500', borderColor: '#FFA500' }}
                >
                  Search
                </button>
              </div>
            </div>
          </div>
          {/* Right Column: Sliding Trip Cards */}
          <div className="col-lg-6 hero-trip-cards-area">
            <div className="p-3 rounded" style={{ minHeight: '300px' }}>
              <h4 className="text-white text-center">Trending Trips</h4>
              <HeroTripCards />
            </div>
          </div>
        </div>
        {/* Add testimonials below the row, full width */}
        <div className="mt-4">
          <Testimonials />
        </div>
      </div>
      <StatsSection />
    </section>
  );
}

export default HeroSection;